import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.3125 3.25V16.25C7.3125 16.707 7.66797 17.0625 8.125 17.0625H17.875V14.625C17.875 13.7617 18.5859 13 19.5 13H21.9375V3.25C21.9375 2.84375 21.5312 2.4375 21.125 2.4375H8.125C7.66797 2.4375 7.3125 2.84375 7.3125 3.25ZM4.875 3.25C4.875 1.47266 6.29688 0 8.125 0H21.125C22.9023 0 24.375 1.47266 24.375 3.25V13.3047C24.375 14.168 24.0195 14.9805 23.4102 15.5898L20.4141 18.5859C19.8047 19.1953 18.9922 19.5 18.1289 19.5H8.125C6.29688 19.5 4.875 18.0781 4.875 16.25V3.25ZM16.25 23.1562C16.25 23.8672 15.6914 24.375 15.0312 24.375H6.90625C3.04688 24.375 0 21.3281 0 17.4688V6.09375C0 5.43359 0.507812 4.875 1.21875 4.875C1.87891 4.875 2.4375 5.43359 2.4375 6.09375V17.4688C2.4375 19.957 4.41797 21.9375 6.90625 21.9375H15.0312C15.6914 21.9375 16.25 22.4961 16.25 23.1562Z",
		fill: "url(#paint0_linear_2153_7567)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_2153_7567",
		x1: -15,
		y1: 11.125,
		x2: 41,
		y2: 11.125,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#74CDFD" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#5FAEFE"
		})]
	}) })]
});
export default SvgNotes;
